import { useMemo } from 'react';
import DataSet from 'choerodon-ui/dataset';
import useConfig from 'choerodon-ui/lib/use-config';
export default function useDataSet(factory, deps) {
    const context = useConfig();
    const getLocalConfig = context.getConfig;
    return useMemo(() => new DataSet(factory(), { getConfig: getLocalConfig }), deps ? [getLocalConfig, ...deps] : [getLocalConfig]);
}
